import { render, staticRenderFns } from "./Parrots.vue?vue&type=template&id=678d7f6e&"
import script from "./Parrots.vue?vue&type=script&lang=ts&"
export * from "./Parrots.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports